var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin-View-Student-Application---Full-data",
    transform: "translate(-815.000000, -2367.000000)",
    stroke: "#3763E8",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 816.628108,
    y1: 2385.37189,
    x2: 831.702695,
    y2: 2385.37189,
    id: "Line-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.38058,2376.57987 L824.269129,2382.18787 C824.637191,2381.83541 825.410568,2381.09481 826.58926,2379.96607 C827.767951,2378.83734 828.946643,2377.70861 830.125335,2376.57987",
    id: "Path-8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.252957,2381.70433 C824.252957,2376.76876 824.252957,2372.20065 824.252957,2368",
    id: "Path-9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownloadIcon);
export default __webpack_public_path__ + "static/media/file-download-icon.f2e3ab1cfeeb6c8145834822fffe6c16.svg";
export { ForwardRef as ReactComponent };